import './App.css';

function Home() {
  return (
    <div className="page">
      <div className="hero">
        <img src="/avatar.jpg" className="avatar" alt="Spencer Kettle" />
        <h1>Spencer Kettle</h1>
        <p className="tagline">Tampa Bay · Real Estate</p>
        <p className="subtagline">Sunday Homes, Founder</p>
      </div>

      <div className="socials">
        <a className="icon-btn" href="https://instagram.com/spencerkettle" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2c2.7 0 3.05.01 4.12.06 1.06.05 1.79.22 2.43.47.66.26 1.22.6 1.77 1.15.55.55.9 1.11 1.15 1.77.25.64.42 1.37.47 2.43.05 1.07.06 1.42.06 4.12s-.01 3.05-.06 4.12c-.05 1.06-.22 1.79-.47 2.43a4.9 4.9 0 0 1-1.15 1.77 4.9 4.9 0 0 1-1.77 1.15c-.64.25-1.37.42-2.43.47-1.07.05-1.42.06-4.12.06s-3.05-.01-4.12-.06c-1.06-.05-1.79-.22-2.43-.47a4.9 4.9 0 0 1-1.77-1.15 4.9 4.9 0 0 1-1.15-1.77c-.25-.64-.42-1.37-.47-2.43C2.01 15.05 2 14.7 2 12s.01-3.05.06-4.12c.05-1.06.22-1.79.47-2.43.26-.66.6-1.22 1.15-1.77A4.9 4.9 0 0 1 5.45 2.53c.64-.25 1.37-.42 2.43-.47C8.95 2.01 9.3 2 12 2zm0 1.8c-2.65 0-2.97.01-4.02.06-.86.04-1.33.18-1.64.3-.41.16-.71.35-1.02.66-.31.31-.5.6-.66 1.02-.12.31-.26.78-.3 1.64-.05 1.05-.06 1.37-.06 4.02s.01 2.97.06 4.02c.04.86.18 1.33.3 1.64.16.41.35.71.66 1.02.31.31.6.5 1.02.66.31.12.78.26 1.64.3 1.05.05 1.37.06 4.02.06s2.97-.01 4.02-.06c.86-.04 1.33-.18 1.64-.3.41-.16.71-.35 1.02-.66.31-.31.5-.6.66-1.02.12-.31.26-.78.3-1.64.05-1.05.06-1.37.06-4.02s-.01-2.97-.06-4.02c-.04-.86-.18-1.33-.3-1.64a2.7 2.7 0 0 0-.66-1.02 2.7 2.7 0 0 0-1.02-.66c-.31-.12-.78-.26-1.64-.3-1.05-.05-1.37-.06-4.02-.06zm0 3.9a4.3 4.3 0 1 1 0 8.6 4.3 4.3 0 0 1 0-8.6zm0 1.8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm5.47-2a1 1 0 1 1-2.01 0 1 1 0 0 1 2.01 0z" />
          </svg>
        </a>
        <a className="icon-btn" href="https://www.facebook.com/share/18zFKMScuN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M13.5 21v-8h2.7l.4-3.1h-3.1V8c0-.9.25-1.5 1.55-1.5H16.7V3.7c-.28-.04-1.25-.12-2.37-.12-2.34 0-3.94 1.43-3.94 4.05v2.25H7.7V13.1h2.69V21h3.1z" />
          </svg>
        </a>
        <a className="icon-btn" href="https://www.linkedin.com/in/spencer-kettle-a67020232" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4.98 3.5C4.98 4.88 3.89 6 2.5 6S0 4.88 0 3.5 1.11 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8.24h4V23h-4V8.24zM8.5 8.24h3.83v2.01h.05c.53-1 1.84-2.06 3.79-2.06 4.05 0 4.8 2.67 4.8 6.14V23h-4v-6.85c0-1.63-.03-3.73-2.27-3.73-2.27 0-2.62 1.77-2.62 3.61V23h-4V8.24z" />
          </svg>
        </a>
        <a className="icon-btn" href="mailto:spencer@sunday.homes" aria-label="Email">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M2 5.5A1.5 1.5 0 0 1 3.5 4h17A1.5 1.5 0 0 1 22 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 18.5v-13zm2.2.5 7.3 5.7a1 1 0 0 0 1.24 0L20 6H4.2zm15.8 1.7-6.87 5.36a2.5 2.5 0 0 1-3.06 0L4.2 7.7V18h15.8V7.7z" />
          </svg>
        </a>
        <a className="icon-btn" href="tel:+18134446140" aria-label="Call">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.2 1.2.4 2.5.6 3.9.6.6 0 1.1.5 1.1 1.1V20c0 .6-.5 1.1-1.1 1.1C10.9 21.1 2.9 13.1 2.9 3.7c0-.6.5-1.1 1.1-1.1h3.4c.6 0 1.1.5 1.1 1.1 0 1.4.2 2.7.6 3.9.1.4 0 .8-.2 1.1L6.6 10.8z" />
          </svg>
        </a>
      </div>

      <div className="divider" />

      <div className="links">
        <a className="link-btn primary" href="https://sunday.homes" target="_blank" rel="noopener noreferrer">
          Visit Sunday Homes
        </a>
        <a className="link-btn" href="https://instagram.com/spencerkettle" target="_blank" rel="noopener noreferrer">
          View Instagram
        </a>
        <a className="link-btn" href="https://www.facebook.com/share/18zFKMScuN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
          View Facebook
        </a>
        <a className="link-btn" href="https://www.linkedin.com/in/spencer-kettle-a67020232" target="_blank" rel="noopener noreferrer">
          Connect on LinkedIn
        </a>
        <a className="link-btn" href="tel:+18134446140">
          Call or Text Me
        </a>
        <a className="link-btn" href="mailto:spencer@sunday.homes">
          Email Me
        </a>
      </div>

      <footer>
        <div className="footer-main">
          <a className="footer-link" href="https://spencerkettle.com" target="_blank" rel="noopener noreferrer">
            spencerkettle.com
          </a>{' · '}
          <a className="footer-link" href="https://sunday.homes" target="_blank" rel="noopener noreferrer">
            sunday.homes
          </a>
        </div>
        <a className="footer-link" href="/privacy.html">
          Privacy Policy
        </a>
      </footer>
    </div>
  );
}

export default Home;
